angular.module('unergie.main')
.filter('camundaAdminUrl', (BoFeaturesService) => {
    const urls = {
        int: 'https://camunda.int.unergie.com',
        preprod: 'https://camunda.preprod.unergie.com',
        prod: 'https://camunda.unergie.com',
    }
    const url = urls[BoFeaturesService.getEnv()]
    return (val) => `${url}/camunda/app/cockpit/default/#/process-instance/${val}`
})
